const en = {
  aiNotice: {
    banner: "✨ The English and Chinese versions of this website are translated using advanced Artificial Intelligence (AI).",
    badge: "🤖 AI Translated",
    dropdownNotice: "English & Chinese translations are generated with AI models.",
    modalTitle: "AI Translation Notice",
    modalText: "To make our educational programs accessible to international visitors, the content in English and Chinese is automatically translated using state-of-the-art Artificial Intelligence."
  },
  nav: {
    home: "Home",
    educations: "Programs",
    programmerOnline: "Artificial Intelligence Programmer - ONLINE",
    programmerLive: "Artificial Intelligence Programmer - IN-PERSON",
    expertOnline: "Artificial Intelligence Specialist - ONLINE",
    aboutUs: "About Us",
    edih: "EDIH",
    blog: "Blog",
    inMedia: "In the Media",
    contact: "Contact",
    applyNow: "Apply Now",
    applyProgrammerOnline: "Programmer ONLINE",
    applyProgrammerLive: "Programmer IN-PERSON",
    applyExpertOnline: "AI Specialist ONLINE",
    languageSelect: "Language"
  },
  hero: {
    badge: "Enrollment in Progress",
    title: "Artificial Intelligence Programmer - ONLINE",
    learnMoreBtn: "Learn More & Apply",
    feature1: "Online lectures and practical exercises",
    feature2: "Free training with HZZ educational vouchers",
    feature3: "Starts: November 2026"
  },
  home: {
    programHeader: "ONLINE PROGRAM - November 2026",
    programTitle: "Artificial Intelligence Programmer - ONLINE",
    programDesc: "This program is designed to equip students through intensive learning with an understanding and practical application of core concepts in programming, data science, machine learning, and deep learning. Students will learn how to program in Python, prepare and analyze data, apply machine learning models, train and evaluate neural networks, and engineer real-world AI applications.",
    eligibility: "Eligible participants:",
    eligibilityText: "Employed and unemployed individuals with at least a secondary school qualification at level 4.2 of the CROQF or higher.",
    funding: "Funding options:",
    fundingText: "HZZ vouchers (100% covered for eligible candidates), company sponsorship, or self-funding.",
    duration: "Program duration:",
    durationText: "6-9 months, depending on lecture scheduling and dynamics",
    start: "Class start date:",
    startText: "November 2026",
    schedule: "Class schedule:",
    scheduleText: "3 times per week, online, starting at 17:30 CET – tailored for working professionals",
    visits: "Visits to Lipik:",
    visitsText: "A total of 5 weekend visits to Lipik (Friday afternoon / Saturday hands-on workshops)",
    ects: "Upon successful completion, students earn 21 CSVET / ECTS credits.",
    readMoreBtn: "Read more and apply",
    blogSectionTitle: "Latest from Our Blog",
    blogSectionSubtitle: "Follow the latest trends, guides, and insights from the world of Artificial Intelligence",
    readMoreLink: "Read more →",
    viewAllBlogsBtn: "View all posts"
  },
  about: {
    header: "ABOUT AI CENTER LIPIK",
    title: "A Synergy of Heritage, Vision, and Technologies of the Future",
    subtitle: "How a historic Slavonian spa town became one of Croatia's most recognized hubs for artificial intelligence education, research, and startup incubation.",
    historyContext: "HISTORICAL CONTEXT",
    historyTitle: "From Imperial Spa to Modern Technology Hub",
    historyP1: "Lipik is a town with a remarkably rich heritage — widely renowned for its century-old spa tourism tradition, healing geothermal springs, state-protected historical park, iconic Kursalon, and the world-famous State Stud Farm of Lipizzan horses.",
    historyP2: "Following severe devastation during the Homeland War, the town was rebuilt with tremendous resilience. Alongside preserving cultural heritage and natural wealth, an ambitious vision emerged: to give young people and future generations a compelling reason to build their lives in Slavonia through high-tech digital innovations.",
    captionKursalon: "Centuries-old park and the Kursalon",
    captionLipizzaner: "Tradition of Lipizzan horses and royal park",
    foundingContext: "FOUNDATION & VISION (2021)",
    foundingTitle: "Lipik Artificial Intelligence Center",
    foundingP1: "The Lipik Artificial Intelligence Center (AI Center Lipik) was officially launched on March 30, 2021, under the auspices of the Lipik Development and Tourism Agency LIRA LLC.",
    foundingP2: "The project's objective was clear: create an ecosystem that connects world-class technical education, expert mentorship, state-of-the-art facilities, and relocation incentives, turning Lipik into a recognized regional AI epicenter.",
    foundingQuote: "“Our vision is simple: empower individuals with 21st-century skills and offer entrepreneurs and tech startups a welcoming home where they can flourish.”",
    captionBuilding: "AI Center building in Lipik",
    captionJetracer: "Hands-on projects with AI models",
    eduContext: "EDUCATION & EXPERTISE",
    eduTitle: "Artificial Intelligence Education Center",
    eduSubtitle: "Our vocational training programs are conducted in academic partnership with the Faculty of Tourism and Rural Development in Požega and supported by national HZZ vouchers, granting graduates formal ECTS credits and recognized micro-credentials.",
    card1Title: "Expert Curriculum",
    card1Desc: "Comprehensive coursework spanning Python, data science, machine learning, deep learning, computer vision, and NLP across 600 to 900 hours of intensive theory and practice.",
    card2Title: "Hands-on Labs & Autonomous Driving",
    card2Desc: "Students apply theory to tangible challenges, including training convolutional neural networks on JetRacer autonomous miniature vehicles and production datasets.",
    card3Title: "Exceptional Employability",
    card3Desc: "Hundreds of graduates from all across Croatia — from Dubrovnik to Osijek — have completed the program, boasting exceptional immediate employment rates in the tech industry.",
    captionClassroom: "Collaborative classroom and team problem-solving",
    captionGraduates: "Proud graduates receiving their official certifications",
    startupContext: "ENTREPRENEURIAL ECOSYSTEM (2022)",
    startupTitle: "Startup Incubator & Accelerator",
    startupP1: "In late 2022, Lipik inaugurated its specialized AI Startup Incubator featuring over 400 m² of modern coworking facilities, private offices, lounge areas, hardware labs, and high-performance server clusters.",
    startupP2: "The incubator provides tech ventures with:",
    startupLi1: "Fully equipped modern offices and high-speed fiber-optic connectivity",
    startupLi2: "Direct mentorship from industry-leading engineering specialists",
    startupLi3: "Start-up funding grants from the City of Lipik, the County, and HZZ",
    startupLi4: "Housing and relocation subsidies for young professionals and families",
    startupP3: "To date, more than 15 tech companies and studios have graduated from incubation, building sophisticated software solutions for clients across Croatia and internationally.",
    captionIncubatorBuilding: "AI Startup Incubator building",
    captionIncubatorOffice: "Modern creative workspaces for startup teams",
    partnerContext: "STRATEGIC PARTNERSHIPS",
    partnerTitle: "Industry & Public Sector Collaborations",
    finaTitle: "FINA AI Development Center",
    finaDesc: "The campus hosts a dedicated Artificial Intelligence Research & Development branch established by Croatia's Financial Agency (FINA). Software engineers stationed in Lipik develop advanced analytical algorithms and next-generation AI tools for national financial infrastructure.",
    edihTitle: "AI & Gaming EDIH",
    edihDesc: "Lipik is a key consortium member of AI & Gaming EDIH — one of only 4 European Digital Innovation Hubs in Croatia, providing fully funded digital transformation services to SMEs and public institutions.",
    ctaTitle: "Interested in Our Programs or Collaboration?",
    ctaDesc: "Whether you want to master AI programming or launch your tech startup in our incubator, our doors are open.",
    ctaBtnEdu: "Explore Programs",
    ctaBtnContact: "Contact Our Team"
  },
  programmerOnline: {
    header: "ONLINE PROGRAM - November 2026",
    title: "Artificial Intelligence Programmer - ONLINE",
    desc: "This program is engineered to provide students with comprehensive proficiency in core programming, data science, machine learning, and deep learning. Students master Python, data curation and analysis, train supervised and unsupervised models, evaluate neural networks, and implement practical AI applications. The curriculum also explores deep learning applications in computer vision.",
    collab: "Delivered in partnership with the Faculty of Tourism and Rural Development in Požega.",
    start: "Class start date: November 2026",
    schedule: "Class schedule: 3 times a week, online, starting at 17:30 CET – accommodating working professionals",
    visits: "Visits to Lipik: 5 scheduled weekend visits (Friday afternoon / Saturday practical sessions)",
    ects: "Graduates earn 21 CSVET / ECTS credits upon completion.",
    applyBtn: "Apply Now",
    curriculumTitle: "Curriculum & Training Schedule",
    eligible: "Eligible participants:",
    eligibleText: "Employed and unemployed candidates who have completed at least secondary education at level 4.2 of the CROQF or higher. Basic familiarity with mathematics, logical reasoning, and computer usage is expected; prior coding or data experience is advantageous. Ideal for professionals seeking career reskilling or upskilling in AI.",
    funding: "Funding options:",
    fundingText: "HZZ vouchers (fully funded for eligible participants), corporate employer sponsorship, or individual payment.",
    cert: "Official credential awarded:",
    certText: "Certificate of completion for the formal micro-credential \"Analyst for Machine and Deep Learning\". Grants 21 ECTS credits.",
    skills: "Competencies, skills, and knowledge acquired:",
    skillsText: "Participants gain comprehensive mastery of modern Python development, data structures, algorithms, data cleaning and preparation pipelines, machine and deep learning model design, neural network architectures, and performance validation. Graduates can independently formulate analytical problems into software architectures, train models using Scikit-Learn, PyTorch, and TensorFlow, interpret statistical results, and communicate findings to both technical and executive audiences.",
    curriculumHeader: "Course Modules:",
    m1: "Python Programming – 180 hours (50h lectures, 70h exercises, 60h self-study)",
    m2: "Introduction to Data Science – 210 hours (50h lectures, 90h exercises, 70h self-study)",
    m3: "Machine Learning – 90 hours (20h lectures, 40h exercises, 30h self-study)",
    m4: "Deep Learning & Computer Vision – 150 hours (40h lectures, 60h exercises, 50h self-study)",
    totalHours: "Total: 630 hours (160h lectures, 260h exercises, 210h independent projects) – 21 ECTS credits",
    duration: "Program duration:",
    durationText: "6-9 months, tailored to lecture cadence and cohort progress.",
    startDetail: "Class start date: November 2026",
    scheduleDetail: "Schedule: 3 times weekly, online at 17:30 CET – designed for working professionals.",
    visitsDetail: "Visits to Lipik: 5 on-site visits (Friday afternoon / Saturday hands-on evaluations).",
    location: "Delivery format:",
    locationText: "Lectures and workshops conducted online via live interactive sessions, combined with 5 weekend sessions at the Lipik AI Center.",
    otherWaysTitle: "Alternative Application Channels",
    otherWaysSubtitle: "You can also enroll using any of the following contact methods:",
    byEmail: "By Email:",
    byEmailText: "Send an email to gabrijela.mijatovic@lipik.ai with your Full Name, email address, and phone number. Our team will promptly guide you through the next steps.",
    byPhone: "By Phone:",
    byPhoneText: "Call +385 (0)99 3808 436 (Gabrijela).",
    inPerson: "In Person:",
    inPersonText: "Visit our campus at Centar umjetne inteligencije Lipik, Hrvatske mladeži 32, 34551 Lipik, Croatia. Hours: Monday - Friday, 07:00 to 15:00 CET."
  },
  programmerLive: {
    header: "IN-PERSON TRAINING IN LIPIK - Spring 2027",
    title: "Artificial Intelligence Programmer - IN-PERSON",
    desc: "An intensive on-site program designed to equip students with deep understanding and hands-on capability in software engineering, data science, machine learning, and neural network development. Work directly with mentors, specialized hardware, and autonomous robots in Lipik.",
    collab: "Conducted in collaboration with the Faculty of Tourism and Rural Development in Požega.",
    start: "Class start date: Spring 2027",
    lectures: "Lectures: Friday afternoons and Saturdays in Lipik",
    exercises: "Exercises: Online once per week",
    ects: "Earn 21 CSVET / ECTS credits upon graduation.",
    durationText: "6 months.",
    locationText: "Lectures take place in-person at the Lipik AI Center premises (Fridays and Saturdays), with supplementary online workshop sessions during the week."
  },
  expertOnline: {
    header: "ONLINE PROGRAM - Spring 2027",
    title: "Artificial Intelligence Specialist - ONLINE",
    desc: "An advanced comprehensive program designed to prepare students for engineering bespoke AI systems in Python, advanced data engineering, training custom neural networks, and deploying cutting-edge deep learning architectures in computer vision and natural language processing (NLP).",
    collab: "Conducted in academic partnership with the Faculty of Tourism and Rural Development in Požega",
    start: "Next cohort start date: Spring 2027",
    ects: "Completion grants 30 CSVET / ECTS credits.",
    eligibleText: "Employed or unemployed candidates holding at least an undergraduate professional or university degree (Bachelor's level or higher).",
    certText: "Formal Certificate of Advanced Training for the micro-credential \"Artificial Intelligence Specialist\". Grants 30 ECTS credits.",
    fundingText: "HZZ Educational Vouchers (free of charge for qualifying candidates), employer co-financing, or self-funded enrollment.",
    skillsText: "Master advanced Python engineering, statistical data modeling, custom neural network architecture design, loss functions, optimization, hyperparameter tuning, transfer learning, transformer architectures for NLP, object detection, segmentation in computer vision, and deployment pipelines.",
    m1: "Python Programming – 150 hours (40h lectures, 60h exercises, 50h self-study)",
    m2: "Machine Learning – 150 hours (40h lectures, 60h exercises, 50h self-study)",
    m3: "Deep Learning – 240 hours (70h lectures, 90h exercises, 80h self-study)",
    m4: "Computer Vision – 120 hours (30h lectures, 50h exercises, 40h self-study)",
    m5: "Introduction to Data Science – 150 hours (40h lectures, 60h exercises, 50h self-study)",
    m6: "Natural Language Processing (NLP) – 90 hours (20h lectures, 40h exercises, 30h self-study)",
    totalHours: "Total: 900 hours (240h lectures, 360h exercises, 300h capstone project) – 30 ECTS credits",
    scheduleTerms: "Lecture & Lab Schedule:",
    term1: "2 to 3 times per week ONLINE (4 academic hours each in the late afternoon/evening, with detailed monthly timetables provided in advance),",
    term2: "A total of 6 weekend visits to Lipik throughout the year (following each major module) for bonus masterclasses (Friday afternoon) and practical assessments (Saturday morning).",
    durationText: "12 months (600 academic hours of lectures and labs, plus 300 hours of independent capstone project development)"
  },
  edih: {
    header: "EUROPEAN DIGITAL INNOVATION HUB",
    title: "AI & GAMING (JURK) EDIH",
    desc: "AI & GAMING (JURK) EDIH operates as a one-stop-shop digital acceleration hub for small and medium-sized enterprises (SMEs) and the public sector in central Croatia and the northern Adriatic region. EDIH facilitates the seamless adoption of advanced digital solutions, with specialized domain expertise in Artificial Intelligence, Gamification, and Blockchain.",
    subDesc: "Digital transformation for small and medium enterprises and the public sector",
    contactBtn: "Contact Us",
    servicesTitle: "Our Services",
    servicesIntro: "All EDIH services are dedicated to accelerating the digital transformation of enterprise and governance, and are 100% free of charge for eligible end-users! The initiative encompasses:",
    s1: "Digital maturity assessment",
    s2: "Support in commercializing innovative ideas and projects",
    s3: "Test before invest (Technical feasibility testing)",
    s4: "Digital twin engineering and simulation",
    s5: "Specialized training & bootcamps (Digital business skills, Gamification, Blockchain, IoT)",
    s6: "24/7 online Microsoft training and skilling platform",
    s7: "Digital health services and medical rehabilitation tech",
    s8: "Business and technology advisory consulting",
    s9: "Pitch coaching and crowdfunding campaign preparation",
    s10: "Investor matchmaking and access to growth capital",
    s11: "Pan-European networking with other EU EDIH hubs",
    consortiumTitle: "Consortium Partners",
    consortiumIntro: "Digitalization and transformation activities are conducted by an 8-partner powerhouse consortium:",
    c1: "Regional Coordinator of Sisak-Moslavina County (Public Institution)",
    c2: "Development Agency SIMORA – Business Incubator PISMO",
    c3: "Institute of Physics, University of Zagreb",
    c4: "Faculty of Organization and Informatics (FOI), University of Zagreb",
    c5: "PAR University College Rijeka",
    c6: "Lipik Artificial Intelligence Center - LIRA Agency",
    c7: "HashNET LLC",
    c8: "FAST LANE LLC",
    focusTitle: "Focus Sectors",
    focusIntro: "Digital transformation services cater to diverse industry sectors, with tailored programs in:",
    f1: "Video game development",
    f2: "Smart agriculture & autonomous driving",
    f3: "Tourism & hospitality",
    f4: "Medical rehabilitation",
    f5: "Wood processing & furniture industry",
    f6: "Smart construction & architecture",
    f7: "Pharmaceuticals & biotechnology",
    f8: "Higher education & ed-tech",
    aboutProjectTitle: "About the Project",
    aboutP1: "The EDIH initiative represents a €2.3 million investment co-funded by the European Commission under the DIGITAL EUROPE Programme and Croatia's National Recovery and Resilience Plan (NPOO 2021-2026). The project officially commenced on December 1, 2022.",
    aboutP2: "AI & GAMING (JURK) EDIH is proud to be part of the initial European Digital Innovation Hubs network of 151 hubs across Europe, of which only 4 operate in Croatia."
  },
  blog: {
    header: "Blog",
    subtitle: "Insights, industry trends, and practical guides from the forefront of Artificial Intelligence.",
    readMore: "Read More",
    backToBlog: "← Back to Blog",
    author: "Author:",
    date: "Date:",
    notFound: "Blog post not found.",
    interestedTitle: "Interested in our AI training programs?",
    programOnlineBtn: "AI Programmer (Online)",
    programLiveBtn: "AI Programmer (In-Person)",
    expertOnlineBtn: "AI Specialist (Online)"
  },
  media: {
    header: "MEDIA COVERAGE & PRESS",
    title: "AI Center Lipik in the Media",
    subtitle: "Explore what leading national and regional press outlets have published about our educational programs, graduates, startup incubator, and AI initiatives.",
    all: "All Articles",
    national: "National Press",
    local: "Regional Press",
    business: "Business Media",
    video: "TV & Video",
    sortNewest: "Newest first",
    sortOldest: "Oldest first",
    readFullArticle: "Read full article on",
    noArticles: "No articles found matching the selected filter."
  },
  contact: {
    title: "Contact",
    subtitle: "Have questions? Reach out via email, phone, or visit our campus in Lipik.",
    addressTitle: "ADDRESS:",
    address: "Lipik Artificial Intelligence Center\nHrvatske mladeži 32\n34551 Lipik, Croatia",
    phoneTitle: "PHONE:",
    phone: "Mobile: +385 (0)99 3808 436 (Gabrijela)",
    emailTitle: "E-MAIL:",
    email: "gabrijela.mijatovic@lipik.ai",
    hoursTitle: "OFFICE HOURS:",
    hours: "Monday - Friday: 07:00 - 15:00 CET",
    mapTitle: "AI Center Lipik Location Map"
  },
  form: {
    title: "Apply Now",
    subtitleSingle: "Fill out the registration form below and secure your spot in the program.",
    subtitleMulti: "Fill out the registration form below and secure your spot in our programs.",
    successAlert: "Your application has been successfully submitted! Thank you for your interest.",
    errorAlert: "An error occurred while sending your application. Please check your contact information.",
    captchaError: "Incorrect math challenge answer. Please try again.",
    selectProgramLabel: "Select Program",
    selectProgramPlaceholder: "Choose the program you wish to apply for",
    prog1: "Artificial Intelligence Programmer - ONLINE",
    prog2: "Artificial Intelligence Programmer - IN-PERSON",
    prog3: "Artificial Intelligence Specialist - ONLINE",
    nameLabel: "Full Name",
    namePlaceholder: "Enter your first and last name",
    emailLabel: "Email Address",
    emailPlaceholder: "your@email.com",
    phoneLabel: "Phone Number",
    phonePlaceholder: "+385 9x xxx xxxx",
    educationLabel: "Highest Level of Education",
    educationPlaceholder: "Select your education level",
    eduSSS: "Secondary Vocational / High School (SSS)",
    eduVSS1: "Associate Degree / Higher Vocational (VŠS)",
    eduVSS2: "Bachelor's / Master's / University Degree (VSS)",
    messageLabel: "Motivation Letter or Question (optional)",
    messagePlaceholder: "Why would you like to enroll, or what questions do you have for us?",
    captchaLabel: "Spam Protection: Are you human?",
    captchaPlaceholder: "Enter result",
    gdprLabel: "I consent to the processing of my personal data for the purpose of the application procedure and communication in compliance with GDPR regulations.",
    submitBtn: "Submit Application",
    submittingBtn: "Submitting..."
  },
  privacy: {
    title: "Privacy & Data Protection Policy",
    subtitle: "Your privacy and trust are paramount to us.",
    p1: "The Lipik Artificial Intelligence Center collects and processes users' personal information through online registration forms solely for the purpose of processing program enrollments and communicating with registered candidates.",
    p2: "During the application process, basic contact information and relevant academic details may be gathered, including full name, email address, telephone number, and information pertaining to educational credentials or HZZ voucher eligibility.",
    p3: "In subsequent registration stages, candidates may be asked to submit additional formal documentation required by educational authorities to finalize their enrollment.",
    p4: "Collected information is strictly utilized to manage course applications, provide essential updates, and share official notices regarding educational programs at AI Center Lipik.",
    p5: "By submitting information via our forms, the user acknowledges and agrees to this Privacy Policy and grants consent to AI Center Lipik to process the submitted data for the specified purposes.",
    cookiesTitle: "Cookies Policy",
    cookiesText: "This website uses cookies to ensure an optimal user experience and seamless site functionality. By continuing to browse, you agree to our use of cookies.",
    contactTitle: "Data Protection Contact",
    contactText: "For any inquiries regarding the processing of your personal information, please contact:",
    email: "Email:",
    address: "Address: Centar umjetne inteligencije Lipik, Hrvatske mladeži 32, 34551 Lipik, Croatia"
  },
  footer: {
    companyName: "LIPIK ARTIFICIAL INTELLIGENCE CENTER",
    companyAgency: "Lipička razvojna i turistička agencija Lipik d.o.o.",
    companyAddress: "Hrvatske mladeži 32, 34551 Lipik, Croatia",
    companyOib: "VAT ID: 54639446953",
    navHeader: "Programs & Education",
    progOnline: "AI Programmer - ONLINE",
    progLive: "AI Programmer - IN-PERSON",
    progExpert: "AI Specialist - ONLINE",
    inMedia: "Center in the Media",
    contactHeader: "CONTACT",
    phone: "Mobile | +385 (0)99 3808 436 (Gabrijela)",
    email: "Email | gabrijela.mijatovic@lipik.ai",
    privacyLink: "Privacy & Data Protection Policy",
    allRightsReserved: "All rights reserved.",
    backToTop: "Back to top",
    aiDisclaimer: "English and Chinese versions are translated with Artificial Intelligence technology."
  },
  cookies: {
    text: "This website uses cookies to ensure you get the best browsing experience. By continuing to browse, you agree to our use of cookies. Learn more in our",
    privacyLink: "Privacy Policy",
    acceptBtn: "I Accept"
  },
  accessibility: {
    title: "Accessibility",
    increaseFont: "A+ Increase Text",
    decreaseFont: "A- Decrease Text",
    contrast: "High Contrast",
    dyslexic: "Dyslexic Font",
    underline: "Underline Links",
    reset: "Reset Settings"
  },
  admin: {
    title: "Administration",
    subtitle: "Enter access code to view applicant records.",
    codePlaceholder: "Code",
    submitBtn: "Access Records",
    wrongCode: "Incorrect code!",
    tableTitle: "Submitted Applications",
    exportBtn: "Export to Excel (.csv)",
    loading: "Loading data...",
    noData: "No applications found.",
    thDate: "Date",
    thName: "Full Name",
    thEmail: "Email",
    thPhone: "Phone",
    thProgram: "Program"
  }
};

export default en;
